module.exports = __webpack_public_path__ + "assets/gear.40f18089cac80bdf38ea18a2c11c2874.svg";